import { TranslatePipe } from '../../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../../utils/session.service';
import RoutingService from '../../../services/routing.service';

@Component({
	standalone: true,
	selector: 'booking-failed',
	templateUrl: './booking-failed.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export default class BookingFailedView implements OnInit {
	private session: Session = inject(Session);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.vm.user = this.session.getSession().user;
		});
	}

}